<template>   
  <div class="col-md-12">
    <barra-navegacao :visiblebutton="true"/>
    <div v-if="!visualizando">
      <b-row class="text-center">
        <b-col cols="12">          
          <div style="margin-bottom:10px"></div>
             <b-col lg="12" class="my-1">
              <b-form-group
                label="Pesquisar"
                label-for="filter-input"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    v-model="filter"
                    type="search"
                    placeholder="Busca por ID, Local..."
                  ></b-form-input>

                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <div style="margin: 10px"></div>
              <b-card bg-variant="light" body-class="p-1 p-md-3" style="min-height: 60vh;">
                  <div class="overflow-auto">
                      <b-table stacked="md" id="table-checklists" @filtered="onFiltered" :filter="filter" :filter-function="filtroPersonalizado" striped small :fields="fields" :items="itensFiltrados" responsive="sm" :per-page="perPage" :current-page="currentPage">
                        
                          <template v-slot:cell(idSolicitacao)="data">
                            <b-badge :variant="data.item.idSolicitacao ? 'info' : 'secondary'">{{ data.item.idSolicitacao ? `#${data.item.idSolicitacao}` : 'Avulso' }}</b-badge>
                        </template>

                        <template v-slot:cell(local)="data">
                           <span>{{ formatarLocal(data.item) }}</span>
                        </template>

                        <template v-slot:cell(status)="data">
                            <b-badge :variant="getBadgeVariant(data.item.status)">{{ mapStatus(data.item.status) }}</b-badge>
                        </template>

                        <template v-slot:cell(autorizado)="data">
                            <b-badge :variant="data.item.autorizado === null ? 'secondary' : (data.item.autorizado ? 'success' : 'danger')">
                                {{ data.item.autorizado === null ? 'Aguardando' : (data.item.autorizado ? 'Sim' : 'Não') }}
                            </b-badge>
                        </template>

                        <template v-slot:cell(ancora)="data">
                            <span>{{ data.item.ancora ? 'Sim' : 'Não' }}</span>
                        </template>

                        <template v-slot:cell(ocorrencias)="data">
                          <div v-if="temOcorrencia(data.item.idCheckList)">
                            <b-button size="sm" :variant="temOcorrenciaNaoFinalizada(data.item.idCheckList) ? 'danger' : 'primary'" @click="irParaOcorrencias(data.item.idCheckList)" title="Ver Ocorrências">Ver</b-button>
                          </div>
                          <div v-else>
                            <b-button size="sm" variant="outline-secondary" disabled title="Nenhuma Ocorrência">Ver</b-button>
                          </div>
                        </template>

                        <template v-slot:cell(acoes)="data">
                            <div class="d-flex align-items-center justify-content-center flex-nowrap">
                                <b-button @click="visualizar(data.item)" class="v-button" size="sm" style="background-color: #303f9f; margin-right: 5px" title="Visualizar"><b-icon icon="eye"></b-icon></b-button>
                                <b-button @click="confirmarCancelamento(data.item)" class="v-button" size="sm" style="background-color: #dc3545;" title="Cancelar" :disabled="data.item.status === 'Can' || !ehAdminOuSupervisor"><b-icon icon="x-circle"></b-icon></b-button>
                            </div>
                        </template>

                      </b-table>
                      <div class="mt-3 d-flex justify-content-end">
                        <b-pagination
                        size="sm"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="table-checklists"
                        ></b-pagination>
                      </div>                      
                  </div>
              </b-card>
        </b-col>
      </b-row>
    </div>
      
      <!-- Visualização Tela Cheia -->
      <div v-else-if="visualizando && checklistSelecionado">
        <!-- <h4 class="mb-3 text-center text-muted">Detalhes do {{ nomeModulo }}</h4> -->
        <b-card bg-variant="light" style="box-shadow: 2px 2px 5px rgba(0,0,0,0.1);">
          <b-row class="mb-3">
            <b-col cols="12" md="3" class="mb-2 mb-md-0"><strong>ID do {{ nomeModulo }}:</strong> {{ checklistSelecionado.idCheckList }}</b-col>
            <b-col cols="12" md="3" class="mb-2 mb-md-0"><strong>Período:</strong> {{ checklistSelecionado.periodoLetivo || '-' }}</b-col>
            <b-col cols="12" md="3" class="mb-2 mb-md-0"><strong>Status:</strong> <b-badge :variant="getBadgeVariant(checklistSelecionado.status)">{{ mapStatus(checklistSelecionado.status) }}</b-badge></b-col>
            <b-col cols="12" md="3" class="mb-2 mb-md-0"><strong>Autorizado:</strong> <b-badge :variant="checklistSelecionado.autorizado === null ? 'secondary' : (checklistSelecionado.autorizado ? 'success' : 'danger')">{{ checklistSelecionado.autorizado === null ? 'Aguardando' : (checklistSelecionado.autorizado ? 'Sim' : 'Não') }}</b-badge></b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="12">
                <strong>Tipo de Registro:</strong> 
                <toggle-button 
                    v-if="ehAdminOuSupervisor && (checklistSelecionado.status === 'Pen' || checklistSelecionado.status === 'Ini')"
                    :value="checklistSelecionado.ancora" 
                    @change="atualizarAncora(checklistSelecionado, $event)" 
                    :sync="true" 
                    :labels="{checked: 'Inventário', unchecked: 'Checklist'}"
                    :color="{checked: '#303f9f', unchecked: '#17a2b8'}"
                    :width="100"
                    class="ml-2"
                />
                <b-badge v-else class="ml-2" :variant="checklistSelecionado.ancora ? 'primary' : 'info'">{{ checklistSelecionado.ancora ? 'Inventário' : 'Checklist' }}</b-badge>
            </b-col>
          </b-row>
          <b-row class="mb-3">
              <b-col cols="12"><strong>Local:</strong> {{ formatarLocal(checklistSelecionado) }}</b-col>
          </b-row>
          <hr>
          <h5 class="mb-3">Itens Verificados</h5>
          
          <b-table v-if="checklistSelecionado.itens && checklistSelecionado.itens.length > 0" striped small :items="checklistSelecionado.itens" :fields="fieldsItens" responsive="sm" stacked="md">
              <template v-slot:cell(nome)="data">
                  {{ data.item.item.nome }}
              </template>
              <template v-slot:cell(quantidade)="data">
                  <b-form-input v-if="checklistSelecionado.status === 'Ini'" type="number" v-model="data.item.quantidade" size="sm" @change="atualizarQuantidade(data.item)" min="0"></b-form-input>
                  <span v-else>{{ data.item.quantidade }}</span>
              </template>
              <template v-slot:cell(observacao)="data">
                  <b-form-textarea v-if="checklistSelecionado.status === 'Ini'" v-model="data.item.observacao" size="sm" rows="1" @change="atualizarObservacao(data.item)"></b-form-textarea>
                  <span v-else>{{ data.item.observacao || '-' }}</span>
              </template>
              <template v-slot:cell(problema)="data">
                  <toggle-button 
                      v-if="checklistSelecionado.status === 'Ini'"
                      :value="data.item.problema" 
                      @change="atualizarProblema(data.item, $event)" 
                      :sync="true" 
                      :labels="{checked: 'Sim', unchecked: 'Não'}"
                      :color="{checked: '#dc3545', unchecked: '#28a745'}"
                      :width="70"
                  />
                  <b-badge v-else :variant="data.item.problema ? 'danger' : 'success'">{{ data.item.problema ? 'Sim' : 'Não' }}</b-badge>
              </template>
              <template v-slot:cell(anexos)="data">
                <check-list-anexos
                  :id-check-list-item="data.item.idCheckListItem"
                  :nome-item="data.item.item ? data.item.item.nome : ''"
                  :anexos="data.item.anexos || []"
                  :habilitado="Boolean(data.item.problema)"
                  :permite-envio="Boolean(data.item.problema) && checklistSelecionado.status === 'Ini'"
                  :permite-exclusao="checklistSelecionado.status !== 'Fin'"
                  @anexos-adicionados="adicionarAnexos(data.item.idCheckListItem, $event)"
                  @anexo-excluido="removerAnexo(data.item.idCheckListItem, $event)"
                />
              </template>
          </b-table>
          <div v-else class="text-center text-muted mb-4 mt-4">Nenhum item registrado neste {{ nomeModulo.toLowerCase() }}.</div>

          <!-- BOTÕES DE AÇÃO -->
          <div class="mt-4 d-flex flex-column flex-md-row justify-content-md-end">
              <b-button :disabled="checklistSelecionado.status !== 'Pen' || !checklistSelecionado.autorizado" variant="primary" size="md" class="mb-2 mb-md-0 mr-md-2" @click="iniciarChecklist(checklistSelecionado)">Iniciar</b-button>
              <b-button :disabled="checklistSelecionado.status !== 'Ini'" variant="success" size="md" class="mb-2 mb-md-0 mr-md-2" @click="finalizarChecklist(checklistSelecionado)">Finalizar</b-button>
              <b-button v-if="ehAdminOuSupervisor" :disabled="checklistSelecionado.autorizado || checklistSelecionado.status === 'Can'" variant="warning" size="md" class="mb-2 mb-md-0 mr-md-2" @click="autorizarChecklist(checklistSelecionado)">Autorizar</b-button>
              <b-button v-if="false" variant="secondary" size="md" @click="fecharVisualizacao()">Voltar</b-button>
          </div>
        </b-card>
      </div>
    </div>
</template>

<script>
import BarraNavegacao from '../../components/BarraNavegacao.vue';
import CheckListAnexos from '../../components/CheckListAnexos.vue';
import ChecklistService from '../../services/ChecklistService';
import OcorrenciaService from '../../services/OcorrenciaService';
import { PerfilService } from '@/services/PerfilService';

export default {
  components: { BarraNavegacao, CheckListAnexos },

  data(){
    return{
      abaAtiva: 0,
      ehAdminOuSupervisor: false,
      checklists: [],
      checklistSelecionado: null,
      ocorrenciasAtivas: [],
      fields: [
        { key: 'idCheckList', label: 'ID', class:'text-center', sortable: true },
        { key: 'periodoLetivo', label: 'Período Letivo' , class:'text-center', sortable: true },
        { key: 'idSolicitacao', label: 'Solicitação', class:'text-center', sortable: true },
        { key: 'local', label: 'Local' , class:'text-center', sortable: true },
        { key: 'status', label: 'Status' , class:'text-center', sortable: true },
        { key: 'autorizado', label: 'Autorizado', class:'text-center', sortable: true },
        { key: 'ancora', label: 'Inventário' , class:'text-center', sortable: true },
        { key: 'ocorrencias', label: 'Ocorrências', class:'text-center', sortable: true },
        { key: 'acoes', label: 'Ações' , class:'text-center' }
      ],
      fieldsItens: [
        { key: 'nome', label: 'Item' },
        { key: 'quantidade', label: 'Quantidade', class: 'text-center' },
        { key: 'observacao', label: 'Observação' },
        { key: 'problema', label: 'Com Problema?', class: 'text-center' },
        { key: 'anexos', label: 'Anexos', class: 'anexos-item-cell' }
      ],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      filter: null,
      filterOn: [],
    }
  },
  
  computed: {
    visualizando() {
      return this.$route.query.visualizando === 'true';
    },
    nomeModulo() {
      return this.abaAtiva === 0 ? 'Inventário' : 'Checklist';
    },
    itensFiltrados() {
      if (this.abaAtiva === 0) {
        return this.checklists.filter(c => c.ancora === true);
      } else {
        return this.checklists.filter(c => c.ancora !== true);
      }
    }
  },

  watch: {
    itensFiltrados(newVal) {
      this.rows = newVal.length;
      this.currentPage = 1;
    },
    $route(to) {
      if (to.meta && to.meta.tipo === 'CHECKLIST') {
          this.abaAtiva = 1;
      } else {
          this.abaAtiva = 0;
      }
    }
  },

  created(){
    if (this.$route.meta && this.$route.meta.tipo === 'CHECKLIST') {
        this.abaAtiva = 1;
    } else {
        this.abaAtiva = 0;
    }

    if (this.visualizando && !this.checklistSelecionado && !this.$route.query.id) {
        this.$router.replace({ query: {} }).catch(()=>{});
    }
    const perfilService = new PerfilService();
    this.ehAdminOuSupervisor = perfilService.ehAdminOuSupervisor;
    if (!this.ehAdminOuSupervisor) {
      this.fields = this.fields.filter(f => f.key !== 'ocorrencias');
    }
    this.listarChecklists();
    this.carregarOcorrencias();

    // Abre direto no detalhe se vier com ?id=X na URL (ex: vindo da tela de solicitacao)
    const idParam = this.$route.query.id;
    if (idParam) {
        this.$loading(true);
        ChecklistService.buscarPorId(idParam).then(res => {
            this.checklistSelecionado = res.data;
            this.$router.replace({ query: { ...this.$route.query, visualizando: 'true' } }).catch(()=>{});
        }).catch(() => {
            this.alertaMensager(`${this.nomeModulo} não encontrado.`, 'Aviso', 'warning');
        }).finally(() => {
            this.$loading(false);
        });
    }
  },

  methods: {
    adicionarAnexos(idCheckListItem, anexos) {
      const item = this.checklistSelecionado.itens.find(atual => atual.idCheckListItem === idCheckListItem);
      if (item) this.$set(item, 'anexos', (item.anexos || []).concat(anexos));
    },

    removerAnexo(idCheckListItem, idAnexo) {
      const item = this.checklistSelecionado.itens.find(atual => atual.idCheckListItem === idCheckListItem);
      if (item) this.$set(item, 'anexos', (item.anexos || []).filter(anexo => anexo.idCheckListAnexo !== idAnexo));
    },

    carregarOcorrencias() {
      OcorrenciaService.buscarOcorrenciasChecklist().then(resOcor => {
        let dados = resOcor.data;
        if (typeof dados === 'string') {
          try { dados = JSON.parse(dados); } catch(e) { dados = []; }
        }
        this.ocorrenciasAtivas = Array.isArray(dados) ? dados : [];
      }).catch(e => console.error("Erro ao buscar ocorrências", e));
    },

    temOcorrencia(idCheckList) {
      if (!this.ocorrenciasAtivas) return false;
      return this.ocorrenciasAtivas.some(o => o.ocorrencia && o.ocorrencia.checkList && Number(o.ocorrencia.checkList.idCheckList) === Number(idCheckList));
    },

    temOcorrenciaNaoFinalizada(idCheckList) {
      if (!this.ocorrenciasAtivas) return false;
      const ocorrenciasDoLocal = this.ocorrenciasAtivas.filter(o => o.ocorrencia && o.ocorrencia.checkList && Number(o.ocorrencia.checkList.idCheckList) === Number(idCheckList));
      if (ocorrenciasDoLocal.length === 0) return false;
      return ocorrenciasDoLocal.some(o => {
         return !o.finalizado && o.statusChamadoGLPI !== 'Finalizado' && (!o.ocorrencia || o.ocorrencia.status !== 'Fin');
      });
    },

    irParaOcorrencias(idCheckList) {
      this.$router.push({ path: '/ocorrencia/gerenciar', query: { filtro: idCheckList } }).catch(()=>{});
    },

    alertaMensager(mensagem, titulo, tipo){
          this.$fire({
              title: titulo,
              text: mensagem,
              type: tipo,
          });
    },

    fecharVisualizacao() {
        const origem = this.$route.query.origem;
        const solicitacaoId = this.$route.query.solicitacaoId;

        if (origem === 'solicitacao' && solicitacaoId) {
            // Se veio da solicitação, volta para os detalhes daquela solicitação
            this.$router.push({ path: '/solicitacao/gerenciar', query: { id: solicitacaoId } }).catch(()=>{});
        } else if (origem === 'ocorrencia') {
            // Se veio da listagem de ocorrências, volta pra lá
            this.$router.push({ path: '/ocorrencia/gerenciar' }).catch(()=>{});
        } else {
            // Caso contrário, volta para a listagem geral de inventários
            this.$router.push({ query: {} }).catch(()=>{});
            this.listarChecklists();
        }
    },

    formatarLocal(item) {
        if (!item) return '';
        let partes = [];
        if (item.bloco && item.bloco.descricao) partes.push(item.bloco.descricao);
        if (item.andar && item.andar.descricao) partes.push(item.andar.descricao);
        if (item.sala && item.sala.descricaoCompleta) partes.push(item.sala.descricaoCompleta);
        return partes.length > 0 ? partes.join(' - ') : 'Não informado';
    },

    onFiltered(filteredItems) {
        this.rows = filteredItems.length;
        this.currentPage = 1;
    },

    filtroPersonalizado(item, filter) {
        if (!filter) return true;
        const termo = filter.toLowerCase();
        
        const idMatch = item.idCheckList && item.idCheckList.toString().includes(termo);
        const localMatch = this.formatarLocal(item).toLowerCase().includes(termo);
        const statusMatch = this.mapStatus(item.status).toLowerCase().includes(termo);
        const periodoMatch = item.periodoLetivo && item.periodoLetivo.toLowerCase().includes(termo);
        const solMatch = item.idSolicitacao && item.idSolicitacao.toString().includes(termo);
        
        return idMatch || localMatch || statusMatch || periodoMatch || solMatch;
    },

    listarChecklists(){
        this.$loading(true);
        ChecklistService.listarTodos().then(res => {
            this.checklists = res.data;
            this.checklists.sort((a, b) => b.idCheckList - a.idCheckList);
            this.rows = this.checklists.length;
        }).catch(err => {
            console.error(err);
            this.alertaMensager("Erro ao listar checklists.", "Erro", "error");
        }).finally(() => {
            this.$loading(false);
        });
    },

    visualizar(checklist){
        this.$loading(true);
        ChecklistService.buscarPorId(checklist.idCheckList).then(res => {
            this.checklistSelecionado = res.data;
            this.$router.push({ query: { visualizando: 'true' } }).catch(()=>{});
        }).catch(() => {
            this.alertaMensager(`Erro ao buscar detalhes do ${this.nomeModulo.toLowerCase()}.`, "Erro", "error");
        }).finally(() => {
            this.$loading(false);
        });
    },

    confirmarCancelamento(checklist) {
        this.$bvModal.msgBoxConfirm(`Tem certeza que deseja cancelar este ${this.nomeModulo.toLowerCase()} (ID ${checklist.idCheckList})?`, {
          title: 'Confirmar Cancelamento',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Sim, cancelar',
          cancelTitle: 'Voltar',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
            if (value) {
                this.$loading(true);
                ChecklistService.mudarStatus(checklist.idCheckList, 'Can').then((res) => {
                    if (res.status === 203) {
                        this.alertaMensager(res.data, "Erro", "error");
                    } else {
                        this.alertaMensager(`${this.nomeModulo} cancelado com sucesso!`, "Sucesso", "success");
                    }
                    this.listarChecklists();
                    if (this.visualizando && this.checklistSelecionado && this.checklistSelecionado.idCheckList === checklist.idCheckList) {
                        this.checklistSelecionado.status = 'Can';
                    }
                }).catch(() => {
                    this.alertaMensager(`Erro ao cancelar o ${this.nomeModulo.toLowerCase()}.`, "Erro", "error");
                }).finally(() => {
                    this.$loading(false);
                });
            }
        });
    },

    atualizarAncora(checklist, event) {
        const isAncora = event.value;
        ChecklistService.definirAncora(checklist.idCheckList, isAncora).then(res => {
            if (res.status === 203) {
                this.alertaMensager(res.data, "Aviso", "warning");
                checklist.ancora = !isAncora;
            } else {
                checklist.ancora = isAncora;
                
                // Se o backend retornou o checklist atualizado com os itens copiados
                if (res.data && res.data.itens) {
                    checklist.itens = res.data.itens;
                }
                
                const idx = this.checklists.findIndex(c => c.idCheckList === checklist.idCheckList);
                if (idx !== -1) {
                    this.checklists[idx].ancora = isAncora;
                }
                
                this.listarChecklists();
                
                this.$bvToast.toast(`Tipo de registro atualizado para ${isAncora ? 'Inventário' : 'Checklist'}`, { variant: 'success', solid: true, autoHideDelay: 2000 });
            }
        }).catch(() => {
            checklist.ancora = !isAncora;
            this.alertaMensager("Erro ao atualizar tipo de registro", "Erro", "error");
        });
    },


    atualizarQuantidade(item) {
        ChecklistService.atualizarItemQuantidade(item.idCheckListItem, item.quantidade)
            .catch(() => this.alertaMensager("Erro ao atualizar quantidade", "Erro", "error"));
    },

    atualizarObservacao(item) {
        ChecklistService.atualizarItemObservacao(item.idCheckListItem, item.observacao)
            .catch(() => this.alertaMensager("Erro ao atualizar observação", "Erro", "error"));
    },

    atualizarProblema(item, event) {
        const novoStatus = event.value;
        ChecklistService.atualizarItemProblema(item.idCheckListItem, novoStatus).then(() => {
            item.problema = novoStatus;
        }).catch(() => {
            item.problema = !novoStatus; // reverte no erro
            this.alertaMensager("Erro ao atualizar problema", "Erro", "error");
        });
    },

    iniciarChecklist(checklist) {
        this.$loading(true);
        ChecklistService.mudarStatus(checklist.idCheckList, 'Ini').then((res) => {
            if (res.status === 203) {
                this.alertaMensager(res.data, "Erro", "error");
            } else {
                checklist.status = 'Ini';
                this.alertaMensager(`${this.nomeModulo} iniciado com sucesso!`, "Sucesso", "success");
                this.listarChecklists();
            }
        }).catch((err) => {
            console.error(err);
            this.alertaMensager(`Erro ao iniciar ${this.nomeModulo.toLowerCase()}`, "Erro", "error");
        }).finally(() => this.$loading(false));
    },

    finalizarChecklist(checklist) {
        this.$bvModal.msgBoxConfirm(`Tem certeza que deseja finalizar este ${this.nomeModulo.toLowerCase()} (ID ${checklist.idCheckList})? Não será possível alterá-lo após isso.`, {
          title: 'Confirmar Finalização',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: 'Sim, finalizar',
          cancelTitle: 'Voltar',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
            if (value) {
                this.$loading(true);
                ChecklistService.mudarStatus(checklist.idCheckList, 'Fin').then((res) => {
                    if (res.status === 203) {
                        this.alertaMensager(res.data, "Erro", "error");
                    } else {
                        checklist.status = 'Fin';
                        this.alertaMensager(`${this.nomeModulo} finalizado com sucesso!`, "Sucesso", "success");
                        this.listarChecklists();
                    }
                }).catch((err) => {
                    console.error(err);
                    this.alertaMensager(`Erro ao finalizar ${this.nomeModulo.toLowerCase()}`, "Erro", "error");
                }).finally(() => this.$loading(false));
            }
        });
    },

    autorizarChecklist(checklist) {
        ChecklistService.autorizar(checklist.idCheckList).then(() => {
            checklist.autorizado = true;
            this.alertaMensager(`${this.nomeModulo} autorizado com sucesso!`, "Sucesso", "success");
            this.listarChecklists();
        }).catch((err) => {
            console.error(err);
            this.alertaMensager(`Erro ao autorizar ${this.nomeModulo.toLowerCase()}`, "Erro", "error");
        }).finally(() => this.$loading(false));
    },

    mapStatus(status) {
        const statusMap = {
            'Pen': 'Pendente',
            'Can': 'Cancelado',
            'Ini': 'Iniciado',
            'Fin': 'Finalizado'
        };
        return statusMap[status] || status;
    },

    getBadgeVariant(status) {
        const variantMap = {
            'Pen': 'warning',
            'Can': 'danger',
            'Ini': 'success',
            'Fin': 'info'
        };
        return variantMap[status] || 'secondary';
    }
  }
}
</script>

<style scoped>
.v-button {
  color: white;
}
</style>
